import { meService } from "@/api/services/meService";
import type { UpdateMe } from "@/types/user";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useMe = () => {
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: ["me"],
    queryFn: () => meService.getMe(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateMe = () => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  return useMutation({
    mutationFn: async (data: {
      id: string;
      userData: Partial<UpdateMe>;
      sub: string;
    }) => {
      return await meService.updateMe(data.userData);
    },
    onSuccess: async (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["me"] });

      try {
        await getAccessTokenSilently({ cacheMode: "off" });
      } catch (error) {
        console.error("Failed to refresh Auth0 user data:", error);
        // Fallback: just reload the page
        setTimeout(() => window.location.reload(), 1000);
      }
    },
  });
};
